module.exports = __webpack_public_path__ + "media/1.53e92a08.mp4";